export const env = process.env.NODE_ENV as "production" | "development";

interface Environment {
  apiHttp: string;
  apiWs: string;
  stripeKey: string;
}

const environment: Environment = {
  apiHttp: process.env.VUE_APP_API_URL_HTTPS,
  apiWs: process.env.VUE_APP_API_URL_WSS,
  stripeKey: process.env.VUE_APP_STRIPE_PUBLISHABLE_KEY,
};

export default environment;
